function asStr(v) {
  return String(v ?? "").trim();
}

/**
 * @param {object} method
 */
export function snapshotTrainerPaymentMethod(method) {
  const picked = method && typeof method === "object" ? method : null;
  if (!picked) return null;
  return {
    payment_type: asStr(picked.payment_type),
    display_name: asStr(picked.display_name),
    is_default: Boolean(picked.is_default),
    is_active: picked.is_active !== false,
    instructions: asStr(picked.instructions),
    details:
      picked.details && typeof picked.details === "object"
        ? { ...picked.details }
        : {},
  };
}

/**
 * @param {object[]} methods
 */
export function pickActiveTrainerPaymentMethods(methods) {
  const list = Array.isArray(methods) ? methods : [];
  return list
    .filter((m) => m?.is_active !== false)
    .sort((a, b) => {
      const def =
        Number(Boolean(b?.is_default)) - Number(Boolean(a?.is_default));
      if (def !== 0) return def;
      return asStr(a?.created_at).localeCompare(asStr(b?.created_at));
    });
}

/**
 * @param {unknown} raw
 * @returns {object[]}
 */
export function normalizeInvoicePaymentMethods(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) {
    return raw.filter((m) => m && typeof m === "object");
  }
  if (typeof raw !== "object") return [];
  const row = raw;
  if (Array.isArray(row.methods)) {
    return row.methods.filter((m) => m && typeof m === "object");
  }
  if (asStr(row.payment_type)) return [row];
  return [];
}

/**
 * Mehrfach-Snapshot ab Versand (neues Format) – nur dann eingefroren, nicht live nachladen.
 *
 * @param {unknown} raw
 */
export function isFrozenMultiMethodPaymentSnapshot(raw) {
  if (!raw || typeof raw !== "object") return false;
  const row = raw;
  return Array.isArray(row.methods) && row.methods.length > 1;
}

/**
 * @param {object[]} methods
 */
export function snapshotActiveTrainerPaymentMethods(methods) {
  const active = pickActiveTrainerPaymentMethods(methods);
  const snapshots = active
    .map((m) => snapshotTrainerPaymentMethod(m))
    .filter(Boolean);
  if (!snapshots.length) return null;
  if (snapshots.length === 1) return snapshots[0];
  return { methods: snapshots };
}
